import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface OrderFileRequest {
    category: string;
    b_file: File[];
    f_c_code?: string;
    f_company?: string;
}

interface OrderFileItem {
    seq: number;
    f_name: string;
    mime: string;
    original_name: string;
}

interface OrderFileResponse {
    statusCode: number;
    message: string;
    data: OrderFileItem[];
}

const createFormData = (data: OrderFileRequest) => {
    const formData = new FormData();
    formData.append("category", data.category);
    if (data.f_c_code) formData.append("f_c_code", data.f_c_code);
    if (data.f_company) formData.append("f_company", data.f_company);
    data.b_file.forEach(file => {
        formData.append("b_file", file);
    });
    return formData;
};

export const usePostOrderFile = (): UseMutationResult<OrderFileResponse, Error, OrderFileRequest, unknown> => {
    return useMutation<OrderFileResponse, Error, OrderFileRequest>({
        mutationFn: async (data: OrderFileRequest) => {
            const formData = createFormData(data);
            const response = await axiosInstance.post(enum_api_uri.order_file, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response.data;
        },
    });
};
